/** @format */

import CloseIcon from '@mui/icons-material/Close';
import {Box, IconButton, Link} from '@mui/material';

import logoImg from 'images/logo__white.svg';

import {NativeMenuNew} from 'components/menus/NativeMenuNew';

import {HeaderBox, HeaderBoxMobile} from './styles';
import {HEADER_ROUTES} from '../constants';

interface Props {
  onToggleDrawer?: () => void;
}

const TopMenuNew = ({onToggleDrawer}: Props) => {
  return (
    <Box>
      {onToggleDrawer && (
        <HeaderBoxMobile>
          <Link href={HEADER_ROUTES.PROJECTS}>
            <img alt='AdSensor Logo' height='30' src={logoImg} />
          </Link>
          <IconButton color='inherit' edge='start' onClick={onToggleDrawer} size='large'>
            <CloseIcon />
          </IconButton>
        </HeaderBoxMobile>
      )}

      <HeaderBox>
        {!onToggleDrawer && (
          <Link href={HEADER_ROUTES.PROJECTS}>
            <img alt='AdSensor Logo' height='30' src={logoImg} />
          </Link>
        )}

        <NativeMenuNew onToggleDrawer={onToggleDrawer} />
      </HeaderBox>
    </Box>
  );
};

export {TopMenuNew};
